import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['barsIcon', 'xmarkIcon', 'container', 'menu'];

  connect() {
    this.openMenu = false;
  }

  toggleMenu() {
    if (this.openMenu) {
      this.barsIconTarget.classList.remove('hidden');
      this.xmarkIconTarget.classList.add('hidden');
      this.containerTarget.classList.remove('h-screen');
      this.menuTarget.classList.add('hidden');
      this.openMenu = false;
    } else {
      this.barsIconTarget.classList.add('hidden');
      this.xmarkIconTarget.classList.remove('hidden');
      this.containerTarget.classList.add('h-screen');
      this.menuTarget.classList.remove('hidden');
      this.openMenu = true;
    }
  }
}
